import { render } from "./RouteItem.vue?vue&type=template&id=93475620"
import script from "./RouteItem.vue?vue&type=script&lang=js"
export * from "./RouteItem.vue?vue&type=script&lang=js"

import "./RouteItem.vue?vue&type=style&index=0&id=93475620&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__